import { _i18n } from '@hestia/ngx-i18n';

export const qnrInfo: { [key: string]: { title: string; info: string } } = {
  'cb31e43f-ba0f-445d-a480-5b3b0b71f010': {
    // ssdq
    title: _i18n('qnr.ssdq.title'),
    info: _i18n('qnr.ssdq.info'),
  },
  '45c9efde-2f78-4ced-a99f-6d965cda95c3': {
    // ssepa
    title: _i18n('qnr.ssepa.title'),
    info: _i18n('qnr.ssepa.info'),
  },
  '984d5e6a-9c7e-43b3-8751-96d63ee317af': {
    // sspph
    title: _i18n('qnr.sspph.title'),
    info: _i18n('qnr.sspph.info'),
  },
  '7d6f4da7-7f2a-414c-bf06-51ac4d77e81d': {
    // ssoph
    title: _i18n('qnr.ssoph.title'),
    info: _i18n('qnr.ssoph.info'),
  },
  'fa9d25bb-d4f2-4738-97e6-c9e6bc7a090e': {
    //	span
    title: _i18n('qnr.span.title'),
    info: _i18n('qnr.span.info'),
  },
  'f1c4993b-05b9-4b57-8d4b-da3c5e87b5cd': {
    //	sptsd
    title: _i18n('qnr.sptsd.title'),
    info: _i18n('qnr.sptsd.info'),
  },
  'bb266315-e1fe-4781-821c-e9310bca9fe6': {
    //	socd
    title: _i18n('qnr.socd.title'),
    info: _i18n('qnr.socd.info'),
  },
  '4c8ad662-61c6-42bf-80dc-9f90c951f59b': {
    //	sbdd
    title: _i18n('qnr.sbdd.title'),
    info: _i18n('qnr.sbdd.info'),
  },
  '783e4fb2-fa83-484e-9a8d-814ac7024c7a': {
    //	sgena
    title: _i18n('qnr.sgena.title'),
    info: _i18n('qnr.sgena.info'),
  },
  'bc258220-c1ff-4255-807b-812635425fe8': {
    //	sdep
    title: _i18n('qnr.sdep.title'),
    info: _i18n('qnr.sdep.info'),
  },
  '95b8a6b9-0d7a-47fe-a79b-d6ce7bc80fe9': {
    //	sdmdd
    title: _i18n('qnr.sdmdd.title'),
    info: _i18n('qnr.sdmdd.info'),
  },
  '4f85f972-236c-4e79-b691-d4f75111db77': {
    //	sbip
    title: _i18n('qnr.sbip.title'),
    info: _i18n('qnr.sbip.info'),
  },
  'b65393f1-9909-4ccb-a791-23ad96a92d03': {
    //	sadhd
    title: _i18n('qnr.sadhd.title'),
    info: _i18n('qnr.sadhd.info'),
  },
  '8effa696-ff0b-45d2-aa06-9955151f74af': {
    //	sodcd
    title: _i18n('qnr.sodcd.title'),
    info: _i18n('qnr.sodcd.info'),
  },
  '84741a29-02db-457c-acec-581afac9526f': {
    //	sub
    title: _i18n('qnr.sub.title'),
    info: _i18n('qnr.sub.info'),
  },
  'fe6e1c41-d951-4664-a96a-22ab7192c1da': {
    //	seat
    title: _i18n('qnr.seat.title'),
    info: _i18n('qnr.seat.info'),
  },
  'cd71bf3d-75f9-4634-baf3-03483e327bfc': {
    //	spsy
    title: _i18n('qnr.spsy.title'),
    info: _i18n('qnr.spsy.info'),
  },
  sotherMissing: {
    // sother
    title: _i18n('qnr.sother.title'),
    info: _i18n('qnr.sother.info'),
  },
  '2cb7777c-7e52-45e6-8a4b-881b5785a5fb': {
    // spos
    title: _i18n('qnr.spos.title'),
    info: _i18n('qnr.spos.info'),
  },
  '432dd48e-de65-48b2-9eb3-7f3cb98021d3': {
    title: _i18n('qnr.stic.title'),
    info: _i18n('qnr.stic.info'),
  },
  'cae27532-c094-4618-a570-5a0a64bd221f': {
    title: _i18n('qnr.sother.title'),
    info: _i18n('qnr.sother.info'),
  },
  'cc7c9ccf-1f4f-4153-af4d-c08f7e04a9f8': {
    title: _i18n('qnr.scomment.title'),
    info: _i18n('qnr.scomment.info'),
  },
  '52e399bd-a585-4855-b13d-663241ade2cd': {
    title: _i18n('qnr.sintro.title'),
    info: _i18n('qnr.sintro.info'),
  },
  '98915d51-b818-474b-ac84-9475699da618':{
    title: _i18n('qnr.psepa.title'),
    info: _i18n('qnr.psepa.info'),
  },
  'f11c962b-7ce3-47c7-9366-b5c5e7dfdd98': {
    title: _i18n('qnr.ppan.title'),
    info: _i18n('qnr.ppan.info')},
    
    '8b11d534-832a-4f82-9bfa-62aee86259c0': {
    title: _i18n('qnr.ppos.title'),
    info: _i18n('qnr.ppos.info')},
    
    '301f136e-a567-4441-9854-f575583ffe32': {
    title: _i18n('qnr.pptsd.title'),
    info: _i18n('qnr.pptsd.info')},
    
    '39c8bce7-f798-4b87-8601-05fc41b43e9c': {
    title: _i18n('qnr.prad.title'),
    info: _i18n('qnr.prad.info')},
    
    '827f21d4-f99d-4f21-accd-6da9f72c06c3': {
    title: _i18n('qnr.psdq.title'),
    info: _i18n('qnr.psdq.info')},
    
    'a40c8eb9-58e5-42bb-968f-919f850da759': {
    title: _i18n('qnr.pother.title'),
    info: _i18n('qnr.pother.info')},
    
    '5f4da9f8-e8e5-4898-87aa-a0cd1b8a998e': {
    title: _i18n('qnr.psoph.title'),
    info: _i18n('qnr.psoph.info')},
    
    '69a69770-61c9-49ad-b201-c25162f56735': {
    title: _i18n('qnr.pspph.title'),
    info: _i18n('qnr.pspph.info')},
    
    'f6e309e8-3a74-4ed2-a37b-9487d45065ba': {
    title: _i18n('qnr.ptic.title'),
    info: _i18n('qnr.ptic.info')},
    
    '41e5f8c3-87ab-4579-82d4-83022917f817': {
    title: _i18n('qnr.pdev.title'),
    info: _i18n('qnr.pdev.info')},
    
    '1efa97ea-96cb-4e38-91d3-90341bf8630f': {
    title: _i18n('qnr.pasd.title'),
    info: _i18n('qnr.pasd.info')},
    
    '649d73b6-5d82-42e0-93a4-29fe6bc80941': {
    title: _i18n('qnr.pbdd.title'),
    info: _i18n('qnr.pbdd.info')},
    
    '6f5c60a3-d982-437d-8c71-d9598080b6aa': {
    title: _i18n('qnr.pbip.title'),
    info: _i18n('qnr.pbip.info')},
    
    '7aed0aef-17e7-4f3e-99a5-1bf9313169ba': {
    title: _i18n('qnr.pdep.title'),
    info: _i18n('qnr.pdep.info')},
    
    '9b711bd0-de79-4bfd-9057-4635db0594ab': {
    title: _i18n('qnr.padhd.title'),
    info: _i18n('qnr.padhd.info')},
    
    '51f8d9cf-3c8c-4709-9eb4-4748e9d87563': {
    title: _i18n('qnr.pdmdd.title'),
    info: _i18n('qnr.pdmdd.info')},
    
    '2bcb8fda-f399-4dc4-bb9d-3e335bb112db': {
    title: _i18n('qnr.peat.title'),
    info: _i18n('qnr.peat.info')},
    
    'd478e295-d361-4b06-8c97-a89a8efa6a5f': {
    title: _i18n('qnr.pest.title'),
    info: _i18n('qnr.pest.info')},
    
    '9defed42-dad6-4dad-bd8b-a827d1518eb5': {
    title: _i18n('qnr.pgena.title'),
    info: _i18n('qnr.pgena.info')},
    
    'fe46c894-c17b-4364-8278-e4eef4952fe9': {
    title: _i18n('qnr.pocd.title'),
    info: _i18n('qnr.pocd.info')},
    
    'b3b968d3-1f6e-46fc-8f43-4b547cfec6f2': {
    title: _i18n('qnr.podcd.title'),
    info: _i18n('qnr.podcd.info')},
    
    '52beb404-89ca-4d2d-91db-64aef00eec7a': {
    title: _i18n('qnr.pcomment.title'),
    info: _i18n('qnr.pcomment.info')},
    
    'c9d97565-e11e-4b6f-98e1-663febf9e794': {
    title: _i18n('qnr.paback.title'),
    info: _i18n('qnr.paback.info')},
    
    '43b5d58b-fad8-4d65-9582-4d3d125c3861': {
    title: _i18n('qnr.pintro.title'),
    info: _i18n('qnr.pintro.info')},

    'b215727c-fa26-4ce6-93af-0cb4bd389721': {
      title: _i18n('qnr.tother.title'), 
      info: _i18n('qnr.tother.info')
    },
    'be0b52a2-3d9a-4bae-ba25-b0636537dc02': 
    {
      title: _i18n('qnr.tsdq.title'), 
      info: _i18n('qnr.tsdq.info')
    },

   'e5f101e9-b451-47a1-9576-085903e80022': {
    title: _i18n('qnr.temot.title'),
    info: _i18n('qnr.temot.info')
   },

   '8f3d111f-6e61-4b11-9266-68c8790b799b': {
     title: _i18n('qnr.tadhd.title'),
     info: _i18n('qnr.tadhd.info')},

   'e0fbc116-acda-4905-ae97-771d03584b54': 
{title: _i18n('qnr.todcd.title'), 
info: _i18n('qnr.todcd.info')},

'347edf27-a1c3-4f3d-b003-477ac0cc1f80': {
  title: _i18n('qnr.tintro.title'), 
  info: _i18n('qnr.tintro.info')
},
'a49a1fdf-71e4-4e4b-ab55-5410eb10d9b9': {
  title: _i18n('qnr.pfinish.title'), 
  info: _i18n('qnr.pfinish.info')
},
'a1feefb7-588d-44f3-8e1f-e65afb82cddb': {
  title: _i18n('qnr.sfinish.title'), 
  info: _i18n('qnr.sfinish.info')
},
'da5e7080-0536-4858-b70c-e5cd9d0a8ad2': {
  title: _i18n('qnr.tfinish.title'), 
  info: _i18n('qnr.tfinish.info')
}

};
